module.exports = __webpack_public_path__ + "img/cbanner.5f577bec.png";